var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 2H5.25C4.0125 2 3 2.9 3 4V20C3 21.1 4.0125 22 5.25 22H18.75C19.9875 22 21 21.1 21 20V4C21 2.9 19.9875 2 18.75 2ZM5.25 4H10.875V12L8.0625 10.5L5.25 12V4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportes);
export default __webpack_public_path__ + "static/media/reportes.565d93ea927c65f6c0645f23ccd6e3eb.svg";
export { ForwardRef as ReactComponent };